import React, { useState } from 'react';
import styles from '../../assets/scss/InventoryManagement/InventoryTable.module.scss';
import settingStyles from '../../assets/scss/Settings/Settings.module.scss';
import { FaDownload } from 'react-icons/fa';
import Pagination from '../../Components/Common/Pagination';
import { useGetAppHistoryQuery } from '../../slices/admin/admin';
import dayjs from 'dayjs';

const DownloadHistory = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);

    const { data, isLoading } = useGetAppHistoryQuery({ offset: currentPage, limit });
    const historyData = data?.data || [];
    const totalRecords = data?.total || 0;

    const totalPages = Math.ceil(totalRecords / limit);

    return (
        <div className={styles.inventoryContainer}>
            <div className={settingStyles.headerRow}>
                <h2 className={settingStyles.header}>
                    <FaDownload style={{ marginRight: '10px' }} />
                    Download History
                </h2>
            </div>

            <div className={styles.tableWrapper}>
                <div className={styles.tableScroll}>
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Phone</th>
                                <th>Platform</th>
                                <th>Downloaded At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                <tr><td colSpan="4" className={styles.noData}>Loading...</td></tr>
                            ) : historyData.length === 0 ? (
                                <tr><td colSpan="4" className={styles.noData}>No data found</td></tr>
                            ) : (
                                historyData.map((item) => (
                                    <tr key={item._id}>
                                        <td>{item.name}</td>
                                        <td className="notranslate">{item.phone}</td>
                                        <td>
                                            {(() => {
                                                const platformMap = {
                                                    'webapp': { label: 'Web App', bg: '#e8f5e9', color: '#008060' },
                                                    'android': { label: 'Android', bg: '#f1f8e9', color: '#689f38' },
                                                    'app': { label: 'App', bg: '#e3f2fd', color: '#3b82f6' },
                                                    'Install App': { label: 'App', bg: '#e3f2fd', color: '#3b82f6' }
                                                };
                                                const config = platformMap[item.type] || platformMap['webapp'];
                                                return (
                                                    <span style={{
                                                        padding: '4px 8px',
                                                        borderRadius: '4px',
                                                        fontSize: '12px',
                                                        backgroundColor: config.bg,
                                                        color: config.color,
                                                        fontWeight: '500'
                                                    }}>
                                                        {config.label}
                                                    </span>
                                                );
                                            })()}
                                        </td>
                                        <td>{dayjs(item.createdAt).format('YYYY-MM-DD hh:mm A')}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className={styles.paginationWrapper}>
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={(page) => setCurrentPage(page)}
                />
                <select
                    className={styles.inputsbtn}
                    value={limit}
                    onChange={(e) => {
                        setLimit(Number(e.target.value));
                        setCurrentPage(1);
                    }}
                >
                    <option value={10}>10 rows</option>
                    <option value={20}>20 rows</option>
                    <option value={50}>50 rows</option>
                </select>
            </div>
        </div>
    );
};

export default DownloadHistory;
